/** Mirrors ngx-doc-viewer `viewerType`. */
export enum PreviewViewerType {
  GOOGLE = 'google',
  OFFICE = 'office',
  MAMMOTH = 'mammoth',
  PDF = 'pdf',
  URL = 'url'
}

/** Local preview switch used by `preview.component.html`. */
export enum PreviewExtension {
  NONE = '',
  IMAGE = 'image',
  PDF = 'pdf',
  VIDEO = 'video',
  URL = 'url'
}
